import { useEffect, useState, type ComponentPropsWithoutRef, type ReactNode } from "react";
import clsx from "clsx";

/** Fade + slide entrance when switching review sub-tabs. */
export function ReviewTabTransition({
  tabKey,
  children,
  className,
  ...rest
}: {
  tabKey: string;
  children: ReactNode;
  className?: string;
} & ComponentPropsWithoutRef<"div">) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    const frame = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(frame);
  }, [tabKey]);

  return (
    <div
      {...rest}
      className={clsx(
        "transition-all duration-300 ease-out",
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2",
        className,
      )}
      data-testid={`review-tab-panel-${tabKey}`}
    >
      {children}
    </div>
  );
}
